import VaporThemeProvider from "@vapor/react-material/styles";

export const serviceVapor = () => [
  {
    target: "$REACT_ROOT_WRAPPER",
    handler: { component: VaporThemeProvider }
  }
];
